import * as React from "react";
import { useParams } from "react-router-dom";

import { connectPageService } from "../../../../application/domain/base/base-application-service";
import {
  ProcManagementService,
  ProcManagementContextProps,
} from "../../../../application/service/service-provider/proc-management/proc-management-service";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderTabs } from "../../../molecules/service-provider-tab";
import { ServiceProviderR } from "../routes";
import { PrimaryButton } from "@graffer-inc/console-design-kit";

type NotAvailableProps = {
  orgId: string;
};

const NotAvailable: React.FC<NotAvailableProps> = ({ orgId }) => {
  return (
    <div className="columns">
      <div className="column">
        <div className="box">
          <div className="content">
            <p>
              このテナントでは、手続きマスタを利用できません。
              <br />
              ライトプラン・スタンダードプランでのみ利用可能です。
              <br />
              ポータルの
              <a href={ServiceProviderR.Products.link({ id: orgId })}>
                製品設定
              </a>
              をご確認ください。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const OrgProcManagement: React.FC<ProcManagementContextProps> = ({
  isAvailable,
  fetchOrgProducts,
}) => {
  const { orgId } = useParams<{ orgId: string }>();
  React.useEffect(() => {
    fetchOrgProducts(orgId);
  }, [fetchOrgProducts, orgId]);

  return (
    <ServiceProviderTemplate
      breadcrumbs={[{ to: ServiceProviderR.Home.link({}), title: "Home" }]}
    >
      <ServiceProviderTabs orgId={orgId} />
      <nav className="level">
        <div className="level-left">
          <p className="level-item">
            {isAvailable && (
              <a
                href={`${ServiceProviderR.ProcManagementProcsList.link({
                  orgId,
                })}`}
              >
                <PrimaryButton text="手続きマスタの設定画面を開く" />
              </a>
            )}
          </p>
        </div>
      </nav>
      {!isAvailable && <NotAvailable orgId={orgId} />}
    </ServiceProviderTemplate>
  );
};

export const ProcManagementContainer = connectPageService(
  OrgProcManagement,
  () => new ProcManagementService(),
);
